import { Component } from '@angular';

import { Modal, ModalProp } from '@mixins/modal.component';
import e from '@types/express';

@Component({
  name: 'uploadClientEvaluationMediaModal',
  template: require('../upload-file-modal/upload-file-modal.html')
})
export class UploadClientEvaluationMediaModalController extends Modal {
  @ModalProp readonly url!: string;

  loadingData = false;
  fileTypesExpanded = false;
  file!: File;

  /**
   * ...
   */
  async sendRequest() {
    const urlParts = this.url.split('/');
    const institutionId = urlParts[2];
    const subGroupId = urlParts[4];
    const clientId = urlParts[6];
    const evaluationId = urlParts[8];

    const buffer = await this.file.arrayBuffer();
    const file = arrayBufferToBase64(buffer);

    const options = {
      institutionId,
      subGroupId,
      clientId,
      evaluationId,
      name: this.file.name,
      file,
      isReport: false
    };

    let data: unknown = null;
    let error: Error | null = null;

    this.loadingData = true;

    try {
      if (this.url.includes('evaluations')) {
        data = await this.$api2.cm.uploadEvaluationMedia(options);
      } else {
        data = await this.$api2.cm.uploadClientMedia(options);
      }
    } catch (err) {
      error = err as Error;
    }

    this.loadingData = false;

    if (!data) {
      return this.notify.error('Failed to upload file.');
    }

    if (error) {
      console.error(error);

      this.notify.error('Failed to upload file: ' + error.message);
    }

    this.notify.success('Media Successfully Uploaded');

    this.$close(data.data);
  }
}

export default UploadClientEvaluationMediaModalController.$module;

//#region Helper Functions

function arrayBufferToBase64(buffer: ArrayBuffer) {
  let binary = '';

  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;

  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
}

//#endregion Helper Functions
